import styled from 'styled-components'

export const AccountDetailSaveBtn = styled.button`
  width: 100%;
  text-align: center;
  background: transparent;
  //color: #fff;
  padding: 0.5rem;
  margin-top: 0.5rem;
  cursor: pointer;
  user-select: none;
  outline: none;
  border: none;

`
export const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;
  margin: 2rem 0;
  height: 95%;
`

export const PageContent = styled.div`
    background-color: ${({ theme }) => theme.pageBg};
    padding: 30px;
    border-radius: 10px;
    width: calc(100% - 1.2rem);
    //box-shadow: 2px 2px 5px 0px ${({ theme }) => theme.newBg1};
`

export const ProfileFormImageSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
  padding: 20px;
  border: 2px solid ${({ theme }) => theme.newBg1};
  border-radius: 5px;
`
export const ProfileFormImageInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`